"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    headline: {
        id: 'error.headline',
        defaultMessage: 'An unexpected error occurred.',
    },
    description: {
        id: 'error.description',
        defaultMessage: 'Try reloading the page.',
    },
});
//# sourceMappingURL=error.js.map